import React, { useCallback, useEffect, useState } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { aiToast } from './shared/ai-toast';

import { fetchWrapper } from '@/lib/fetch-wrapper';
import { urls } from '@/urls';

interface ToolRow {
  name: string;
  riskClass: string;
  description: string;
}

function ToolsCatalogTab() {
  const [tools, setTools] = useState<ToolRow[] | null>(null);

  const load = useCallback(async () => {
    const toolsData = await fetchWrapper.get(urls.DevOps.agentTools);
    setTools(toolsData);
  }, []);

  useEffect(() => {
    load().catch(() => aiToast.error('Failed to load tools catalog'));
  }, [load]);

  if (!tools) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6">Tools catalog</Typography>
        <Typography variant="body2" color="text.secondary">
          Agent tools available to the bot, with risk class and description.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        {tools.length === 0 ? (
          <Alert severity="info">No tools registered.</Alert>
        ) : (
          <Table size="small" data-testid="agent-tools-table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Risk</TableCell>
                <TableCell>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tools.map((tool) => (
                <TableRow key={tool.name}>
                  <TableCell>{tool.name}</TableCell>
                  <TableCell>{tool.riskClass}</TableCell>
                  <TableCell>{tool.description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Grid>
    </Grid>
  );
}

export default ToolsCatalogTab;
